<div class="header bg-gradient-danger py-7 py-lg-8">
  <div class="container">
    <div class="header-body text-center mb-6 mt--5">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <h1 class="text-white">{{ 'emailPreferences.title' | translate }}</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="separator separator-bottom separator-skew zindex-100">
    <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
    </svg>
  </div>
</div>

<div class="container mt--8 pb-5">
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-8">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div *ngIf="loading" class="text-center text-muted">
            <small>{{ 'emailPreferences.loading' | translate }}</small>
          </div>

          <div *ngIf="!loading && loadError" class="text-center text-muted">
            <small>{{ 'emailPreferences.invalid' | translate }}</small>
          </div>

          <form *ngIf="!loading && !loadError" [formGroup]="formGroup" (ngSubmit)="save()">
            <div class="text-center text-muted mb-4">
              <small>{{ 'emailPreferences.description' | translate }}</small>
            </div>

            <div class="alert alert-light border mb-4" role="status">
              <div class="mb-1" *ngIf="preferences?.userName"><strong>{{ preferences?.userName }}</strong></div>
              <div class="mb-1" *ngIf="preferences?.email">{{ preferences?.email }}</div>
              <div *ngIf="preferences?.tenantName">{{ preferences?.tenantName }}</div>
            </div>

            <div class="form-group">
              <label class="form-control-label" for="mailSettings">
                {{ 'emailPreferences.operationalLabel' | translate }}
              </label>
              <select id="mailSettings" class="form-control" formControlName="mailSettings">
                <option *ngFor="let option of mailSettingsOptions" [value]="option">
                  {{ ('settings.mail_settings.' + option.toLowerCase()) | translate }}
                </option>
              </select>
              <small class="text-muted">{{ 'emailPreferences.operationalHint' | translate }}</small>
            </div>

            <div class="custom-control custom-checkbox mt-4">
              <input
                id="commercialMailEnabled"
                type="checkbox"
                class="custom-control-input"
                formControlName="commercialMailEnabled"
              >
              <label class="custom-control-label" for="commercialMailEnabled">
                {{ 'emailPreferences.commercialLabel' | translate }}
              </label>
            </div>
            <small class="text-muted d-block mt-2">{{ 'emailPreferences.commercialHint' | translate }}</small>

            <div class="text-center mt-4">
              <button type="submit" class="btn btn-primary" [disabled]="saving">
                {{ saving ? ('emailPreferences.saving' | translate) : ('emailPreferences.save' | translate) }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
